// src/pages/VisionMissionPage.js
import React from 'react';
import visionLogo from '../images/vision-logo.jpg';
import missionLogo from '../images/mission-logo.png';

const VisionMissionPage = () => {
  return (
    <article id="vision-mission" className="content-section">
      <h2 className="section-title">Vision and Mission</h2>
      <div className="vm-container">
        <div className="vm-card">
          <div className="vm-icon-wrapper">
            <img src={visionLogo} alt="Vision" className="vm-icon" />
          </div>
          <h4 className="vm-title">Vision : -</h4>
          <p className="vm-text">
            "To provide educational opportunities to the rural students of our area and illuminate the lives of the students with the divine boon of knowledge to make their careers to eradicate the darkness of their lives."
          </p>
        </div>

        <div className="vm-card">
          <div className="vm-icon-wrapper">
            <img src={missionLogo} alt="Mission" className="vm-icon" />
          </div>
          <h4 className="vm-title">Mission : -</h4>
          <ul className="vm-list">
            <li>To impart qualitative and valuable services in the field of teacher education to the students.</li>
            <li>To inculcate discipline in terms of regularity, sincerity and punctuality among students.</li>
            <li>To provide atmosphere for the all round development of the students.</li>
            <li>To develop civic sense among students.</li>
            <li>To inculcate values among students.</li>
            <li>To provide responsible teachers to the society.</li>
            <li>To attain community and social development through infrastructural facilities of institution.</li>
            <li>To provide facilities in research work to the research scholars in the field of education.</li>
            <li>To develop school- institution- community networking.</li>
            <li>To turn out physically sound and mentally alert teachers.</li>
            <li>To create sportive atmosphere among the college and society.</li>
          </ul>
        </div>
      </div>
    </article>
  );
};

export default VisionMissionPage;
